import L from 'leaflet';
import 'maplibre-gl/dist/maplibre-gl.css';
import '@maplibre/maplibre-gl-leaflet';
import './leaflet-attribution.css';
import {
  CARTO_BASEMAP_ATTRIBUTION,
  getCartoBasemapStyleUrl,
  readCartoBasemapApiKey,
} from './cartoBasemapUrl';
import { configureMapLibreWorker } from './mapLibreWorker';

configureMapLibreWorker();

export { CARTO_VOYAGER_GL_STYLE, getCartoBasemapStyleUrl } from './cartoBasemapUrl';

type MaplibreGlFactory = (options: { style: string; attribution?: string }) => L.Layer;

export function addCartoVectorLayer(map: L.Map): L.Layer {
  const factory = (L as typeof L & { maplibreGL?: MaplibreGlFactory }).maplibreGL;
  if (!factory) {
    throw new Error('maplibre-gl-leaflet did not attach L.maplibreGL');
  }
  const layer = factory({
    style: getCartoBasemapStyleUrl(readCartoBasemapApiKey()),
    attribution: CARTO_BASEMAP_ATTRIBUTION,
  });
  layer.addTo(map);
  return layer;
}
